import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

export interface SelectOption {
  label: string;
  value: any;
  disabled?: boolean;
}

export type SelectAppearance = 'outline' | 'fill';

@Component({
  selector: 'app-form-select',
  templateUrl: './form-select.component.html',
  styleUrls: ['./form-select.component.scss'],
  standalone: false,
})
export class FormSelectComponent {
  @Input() label: string = '';
  @Input() appearance: SelectAppearance = 'outline';
  @Input() options: SelectOption[] = [];
  @Input() formControl: FormControl | null = null;
  @Input() formGroup: FormGroup | null = null;
  @Input() controlName: string = '';
  @Input() errorMessage: string = '';
  @Input() hint: string = '';
  @Input() disabled: boolean = false;
  @Input() required: boolean = false;
  @Input() multiple: boolean = false;
  @Input() id: string = '';
  @Input() useMaterial: boolean = true; // Use Material form field

  @Output() valueChange = new EventEmitter<any>();
  @Output() blur = new EventEmitter<void>();
  @Output() focus = new EventEmitter<void>();

  get control(): FormControl | null {
    if (this.formControl) {
      return this.formControl;
    }
    if (this.formGroup && this.controlName) {
      return this.formGroup.get(this.controlName) as FormControl;
    }
    return null;
  }

  get isInvalid(): boolean {
    return this.control ? this.control.invalid && this.control.touched : false;
  }

  get displayError(): string {
    if (!this.isInvalid) return '';

    if (this.errorMessage) return this.errorMessage;

    const errors = this.control?.errors;
    if (!errors) return '';

    if (errors['required']) return `${this.label || 'Please select'} an option`;
    if (errors['pattern']) return 'Please select a valid option';

    return 'Invalid selection';
  }

  onValueChange(value: any) {
    this.valueChange.emit(value);
  }

  onBlur() {
    if (this.control) {
      this.control.markAsTouched();
    }
    this.blur.emit();
  }

  onFocus() {
    this.focus.emit();
  }
}
